import { render, staticRenderFns } from "./DanInfo.vue?vue&type=template&id=a58bf292&scoped=true"
import script from "./DanInfo.vue?vue&type=script&lang=js"
export * from "./DanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58bf292",
  null
  
)

export default component.exports